import React from 'react';

function Search(props) {
	return (
		

		<div class="input-group d-flex justify-content-end">
			<input type="text" class="form-control" placeholder={props.placeholder} style={searchStyle} onChange={props.searchTerm} value={props.value}/>
			<div class="input-group-append">
			<span class="input-group-text"><i className="fas fa-search form-control-feedback"></i></span>
  			</div>
		</div>
	);
}

const searchStyle = {
	
}

export default Search;
